import React from 'react';
import loadable from '@loadable/component';

const LifestyleCalculator = (props) => {
  const Component = loadable(() => import('./LifestyleCalculator.js'), { ssr: false });
  return <Component {...props} />;
};

export default LifestyleCalculator;
